import config from "@/config"
import store from "@/store"

export const Columns = [
    {
        title: "渠道",
        dataIndex: "channel_name",
        width: 150,
        filter: {
            type: "select",
            options: store.getters["common/channel"]
        },
        renderType: "select",
        renderProps: {
            options: store.getters["common/channel"]
        }
    },
    {
        title: "上架平台",
        dataIndex: "product_sub_type",
        width: 150,
        filter: {
            type: "select",
            options: store.getters["common/product_sub_type"]
        },
        renderType: "select",
        renderProps: {
            options: store.getters["common/product_sub_type"]
        }
    },
    {
        title: "发布版本",
        dataIndex: "version_name",
        width: 150,
        filter: {
            type: "input"
        }
    },
    {
        title: "发布比例",
        dataIndex: "release_ratio",
        width: 150,
        filter: {
            type: "number",
            maxPlaceholder: "%",
            minPlaceholder: "%"
        }
    },
    {
        title: "发布人",
        dataIndex: "release_user",
        width: 100,
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        },
        renderType: "user"
    },
    {
        title: "更新时间",
        dataIndex: "update_time",
        width: 150,
        renderType: "date",
        renderProps: {
            format: "YYYY-MM-DD HH:mm:ss"
        }
    }
]
